var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"mt-5 pa-0 white--text sfh-login-header border-radius-0",attrs:{"flat":"","height":"55"}},[_vm._v("\n  © Copyright "+_vm._s(new Date().getFullYear())+", Cogneti LLC\n  "),_c('v-spacer'),_vm._v(" "),_c('img',{staticClass:"pr-2 mt-1",attrs:{"src":"static/images/ansi-blue-inverse.png","alt":"ANSI","height":"40"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50206c93","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Footer.vue
// module id = 412
// module chunks = 4